module.exports = __webpack_public_path__ + "img/3d76b0a.png";